// extracted by mini-css-extract-plugin
module.exports = {"button":"_b762ad9","icon":"_426f816"};